import React from "react";

const Box = (props: any) => {
  return <div {...props} className={`box ${props?.className || ""}`}></div>;
};

export default Box;
